<template>
    <transition name="fade">
        <div
            v-if="isHelpPanelOpen"
            class="absolute inset-0 bg-black/50 z-[100]"
            @click="closeHelpPanel"
        />
    </transition>
</template>

<script>
    import allStores from '../../stores/all';

    export default {
        name: 'OverlayPanel',

        mixins: [allStores],

        computed: {
            isHelpPanelOpen() {
                return this.customizerStore.isHelpPanelOpen;
            },
        },

        methods: {
            closeHelpPanel() {
                this.customizerStore.closeHelpPanel();
            },
        },
    };
</script>
